{
  "global.siteDescription": "30초로 나를 제대로 소개하고, 사람들이 빠르게 알아볼 수 있게 하세요.",
  "global.languageSwitch": "언어 전환",
  "global.languageCurrent": "현재 언어: {locale}",
  "global.language.zh-CN": "中文",
  "global.language.zh-TW": "繁體中文",
  "global.language.en": "English",
  "global.language.ja": "日本語",
  "global.language.ko": "한국어",
  "global.language.es": "Español",
  "global.language.fr": "Français",
  "global.language.de": "Deutsch",
  "global.language.pt-BR": "Português (Brasil)",
  "global.language.ru": "Русский",
  "global.language.ar": "العربية",
  "common.close": "닫기",
  "common.cancel": "취소",
  "common.save": "저장",
  "common.delete": "삭제",
  "common.edit": "편집",
  "common.manage": "관리",
  "common.login": "로그인",
  "common.logout": "로그아웃",
  "common.loggingOut": "로그아웃 중",
  "common.logoutRetry": "로그아웃 다시 시도",
  "common.preview": "미리보기",
  "common.email": "Email",
  "common.inviteCode": "초대 코드",
  "common.loading": "로드 중",
  "editor.publish.processing": "아직 처리 중입니다",
  "common.localDraft": "로컬 초안",
  "common.publicBeta": "공개 베타",
  "common.serviceStatus": "서비스 상태",
  "common.optional": "선택 사항",
  "common.page": "페이지",
  "common.reason": "이유",
  "common.description": "추가 설명",
  "common.submit": "제출",
  "nav.login": "로그인",
  "nav.draftFirst": "초안 시작",
  "home.action.create": "내 소개 만들기",
  "home.action.continue": "계속 쓰기",
  "home.action.manage": "소개 관리",
  "home.action.agent": "Agent가 대신 작성",
  "home.meta.title": "30s.to — 30초, 나를 알리는 시간.",
  "home.meta.description": "혼자 나아갈수록, 나를 알리는 일이 더 중요해요. 30초, 나를 알리는 시간. 어떤 사람인지, 지금 하는 일과 해온 일, 나눌 수 있는 자원을 소개하세요. 관심이 가는 점을 발견하고 서로 연결될 수 있도록요.",
  "home.title": "30초,\n나를 알리는 시간.",
  "home.freeNote": "작성, 게시, 공유까지. 영원히 무료.",
  "home.kicker": "혼자 나아갈수록, 나를 알리는 일이 더 중요해요.",
  "home.value.copy": "어떤 사람인지, 지금 하는 일과 해온 일, 나눌 수 있는 자원을 소개하세요. 관심이 가는 점을 발견하고 서로 연결될 수 있도록요.",
  "home.features.label": "제품 특징",
  "home.features.time.tab": "30초면 읽어요",
  "home.why.copy": "가장 중요한 것만 쓰세요. 소개가 길수록 끝까지 읽는 사람은 줄어듭니다. 30초가 딱 좋습니다.",
  "home.principle.expression.title": "자유롭게 표현하기",
  "home.principle.expression.copy": "경험, 작업물, 생각과 자원을 나만의 방식으로 구성하세요. 사람들이 알아줬으면 하는 나를 소개하세요.",
  "home.principle.link.title": "나만의 30s.to 링크",
  "home.principle.link.copy": "30s.to/@you는 짧고 기억하기 쉬우며, 뜻도 명확합니다. 30초 만에 나를 알아가는 링크입니다.",
  "home.principle.theme.title": "다양한 테마로 나답게",
  "home.principle.theme.copy": "깔끔하게, 레트로하게, 또는 대담하고 선명하게. 나다운 테마를 골라 첫눈에 내 스타일이 전해지는 소개를 만들어 보세요.",
  "home.footer.tagline": "덜 말할수록, 중요한 것이 더 잘 보입니다.",
  "home.footer.navigation": "바닥글 탐색",
  "home.demo.linkNotice": "이것은 데모 링크입니다. 30초 소개를 만들어 나만의 소개를 추가하세요.",
  "home.demo.profile.name": "마야 첸",
  "home.demo.profile.identity": "복잡한 문제를 단순한 제품으로 바꾸는 독립 제품 디자이너",
  "home.demo.profile.tag.product": "제품 디자인",
  "home.demo.profile.tag.indie": "인디 제품",
  "home.demo.profile.tag.ai": "AI 도구",
  "home.demo.profile.body": "## 요즘\n독립 디자이너가 메모를 옮기는 대신 사람을 이해하는 데 시간을 쓰도록 Briefly를 만들고 있습니다. 설계 전에는 사용자와 실제 작업을 함께 따라가 봅니다.\n\n## 나의 경험\n2020–2023년 협업 소프트웨어 팀에서 편집기와 신규 사용자 안내를 설계했습니다. 엔지니어와 복잡한 작업을 실행 가능한 단계로 나눴습니다.\n\n2024년부터 독립하여 초기 팀의 사용자 조사와 인터랙션 설계를 돕고, 제 작은 제품도 다듬고 있습니다.\n\n## 프로젝트\n- [Relay](https://example.com/projects/relay): 제가 설계한 팀 의사결정 기록 도구입니다. 결론, 이유, 담당자를 묶어 새로 합류한 사람도 배경을 이해하도록 합니다.\n- [Briefly](https://example.com/projects/briefly): 소규모 시험 중인 인터뷰 메모 도구입니다. 원문을 보존하며 기록을 출처 확인이 가능한 주제로 정리합니다.\n\n## 나눌 수 있는 것\n사용자 의견은 있지만 무엇부터 바꿀지 고민된다면 문제 정리와 테스트용 프로토타입을 도울 수 있습니다. 조사를 시작하는 작은 팀에 인터뷰 가이드와 기록 양식도 공유합니다.\n\n## 함께 이야기해요\n작은 제품을 정성껏 만드는 분들과 첫 인터뷰, 선택과 포기, 독립적인 일에 관해 이야기하고 싶습니다. 주말에는 동네 가게를 둘러봅니다. 손으로 쓴 가격표에서 제품 설명보다 더 배울 때도 있습니다.",
  "home.demo.profile.link.website": "일하다",
  "home.demo.profile.link.github": "GitHub",
  "home.demo.profile.link.calendar": "채팅 예약",
  "handleStart.kicker": "공개 URL",
  "handleStart.title": "30s.to URL을 선택하세요",
  "handleStart.copy": "기억하기 쉬운 URL을 먼저 고른 다음 30초 소개를 작성하세요. 기존 초안은 그대로 유지됩니다.",
  "handleStart.label": "내 URL",
  "handleStart.help.empty": "영문 소문자 4~24자. 지금은 초안만 저장하며, 게시할 때 사용 가능 여부를 확인합니다.",
  "handleStart.help.ok": "사용 가능한 형식입니다. 게시할 때 사용 가능 여부를 다시 확인합니다.",
  "handleStart.submit": "계속 쓰기",
  "handleAvailability.checking": "이 URL을 확인하는 중…",
  "handleAvailability.available": "현재 사용할 수 있습니다. 게시가 완료되면 내 URL이 됩니다.",
  "handleAvailability.owned": "현재 내가 소유한 URL입니다.",
  "handleAvailability.assigned": "내게 배정된 URL입니다. 게시 후 적용됩니다.",
  "handleAvailability.failed": "URL 상태를 확인할 수 없습니다. 다시 시도해 주세요.",
  "handleAvailability.rateLimited": "확인 요청이 너무 많습니다. {minutes}분 후 다시 시도해 주세요.",
  "handleAvailability.retry": "다시 확인",
  "handleAvailability.suggestions": "다음 주소도 사용할 수 있어요",
  "handleAvailability.cooldown": "공개 URL은 30일 변경 대기 기간 중입니다. {date} 이후 다시 변경할 수 있으며, 현재 게시된 URL로 되돌릴 수도 있습니다.",
  "editor.shell.loading": "생성 흐름 로드 중",
  "editor.shell.workspace": "30초 소개 작업 공간",
  "editor.shell.canvas": "30초 소개 쓰기 화면",
  "editor.command.aria": "편집기 명령 모음",
  "editor.command.publish": "게시",
  "editor.command.publishUpdate": "변경사항 게시",
  "editor.command.publishSettings": "게시 설정",
  "editor.command.dashboard": "Dashboard",
  "editor.publish.success": "게시됨",
  "editor.publish.successAfterLogin": "로그인하여 게시됨",
  "editor.publish.publishing": "게시 중…",
  "editor.publish.publishingDetail": "공개 페이지를 준비하고 있습니다. 잠시만 기다려 주세요.",
  "editor.publish.successDetail": "공개 페이지가 업데이트되었습니다. 지금 확인할 수 있습니다.",
  "editor.publish.viewPublic": "공개 페이지 보기",
  "editor.publish.cacheFailed": "그러나 공개 페이지 캐시 쓰기에 실패했습니다.",
  "editor.command.login": "로그인",
  "editor.handle.editTitle": "공개 주소 수정",
  "editor.handle.claimAfterPublish": "게시 후 귀하의 것",
  "editor.handle.claimAfterPublishTitle": "게시 후 이 주소는 귀하의 주소가 됩니다.",
  "editor.status.signedIn": "로그인됨",
  "editor.status.account": "계정: {email}",
  "editor.status.localTitle": "지역 초안",
  "editor.status.localCopy": "이 초안은 이 기기에만 저장됩니다. 클라우드에 동기화하려면 로그인하세요.",
  "editor.status.location": "위치 저장",
  "editor.status.state": "상태 저장",
  "editor.status.emailLogin": "Email 로그인",
  "editor.autosave.savingShort": "저장 중",
  "editor.autosave.savedCloudShort": "클라우드에 저장됨",
  "editor.autosave.savedLocalShort": "로컬에 저장됨",
  "editor.autosave.failedShort": "저장 실패",
  "editor.autosave.signedInShort": "로그인됨",
  "editor.autosave.cloud": "구름",
  "editor.autosave.retry": "재시도 필요",
  "editor.autosave.device": "이 장치",
  "editor.autosave.saving": "자동 저장...",
  "editor.autosave.savedLocal": "로컬에 자동 저장됨",
  "editor.autosave.savedCloud": "클라우드에 자동 저장됨",
  "editor.autosave.authExpired": "세션이 만료되었습니다. 로컬에 저장되었습니다.",
  "editor.autosave.cloudFailed": "클라우드 저장에 실패했습니다. 로컬에 저장되었습니다.",
  "editor.autosave.cloudUnavailable": "클라우드 저장이 아직 연결되지 않았습니다. 로컬에 저장되었습니다.",
  "editor.autosave.failed": "자동 저장에 실패했습니다. 콘텐츠를 복사하고 다시 시도하세요.",
  "editor.autosave.enabled": "자동 저장이 켜져 있습니다.",
  "identity.namePlaceholder": "당신의 이름",
  "identity.nameAria": "이름이나 별명",
  "identity.identityPlaceholder": "한줄 아이덴티티",
  "identity.identityAria": "한줄 아이덴티티",
  "identity.tagsAria": "태그",
  "identity.addTag": "태그 추가",
  "identity.removeTag": "{tag} 태그 제거",
  "body.emptyInstruction": "처음 만난 사람이 꼭 알아야 할 내용을 적어 보세요.\n조금 덜 써야 중요한 내용이 보입니다. 30초면 딱 좋습니다.",
  "body.templatesLabel": "템플릿으로 시작해도 좋아요",
  "body.templatesAria": "본문 정체성 템플릿",
  "body.templateExampleLabel": "예시 프로필",
  "body.viewTemplateExample": "예시 보기",
  "links.sectionAria": "모래밭",
  "links.documentTitle": "모래밭",
  "links.documentCopy": "소셜 프로필, 예약, 연락처 정보",
  "links.documentEmptyCopy": "소셜 프로필, 예약 페이지 또는 연락 방법을 추가하세요. 언제든지 변경할 수 있습니다.",
  "links.add": "링크 추가",
  "links.addType": "{label} 추가",
  "links.edit": "{label} 편집",
  "links.addedAria": "링크를 추가했습니다.",
  "links.closePanel": "링크 편집기 닫기",
  "links.editTitle": "링크 수정",
  "links.addTitle": "링크 추가",
  "links.chooseTypeAgain": "링크 유형을 다시 선택하세요",
  "links.calendarProvider": "예약 제공업체",
  "links.displayName": "표시 이름",
  "links.duplicate": "{label}가 이미 추가되었습니다.",
  "links.alreadyAdded": "{label}가 이미 추가되었습니다.",
  "links.bookingAlreadyAdded": "예약이 이미 추가되었습니다",
  "links.remove": "삭제",
  "links.category.social": "사회의",
  "links.category.booking": "예약",
  "links.category.work": "작업물 / 웹사이트",
  "links.category.content": "콘텐츠",
  "links.category.contact": "연락하다",
  "links.category.other": "다른",
  "links.type.x": "엑스",
  "links.type.github": "GitHub",
  "links.type.linkedin": "LinkedIn",
  "links.type.instagram": "Instagram",
  "links.type.youtube": "YouTube",
  "links.type.bilibili": "Bilibili",
  "links.type.xiaohongshu": "샤오홍슈",
  "links.type.wechat": "위챗 공식 계정",
  "links.type.email": "Email",
  "links.type.calendar": "예약",
  "links.type.website": "웹사이트",
  "links.type.newsletter": "Newsletter",
  "links.type.tiktok": "TikTok",
  "links.type.threads": "Threads",
  "links.type.mastodon": "Mastodon",
  "links.type.dribbble": "Dribbble",
  "links.type.jike": "지케",
  "links.type.other": "다른",
  "links.input.x": "X 핸들",
  "links.input.github": "GitHub 핸들",
  "links.input.linkedin": "LinkedIn URL",
  "links.input.instagram": "Instagram 핸들",
  "links.input.youtube": "YouTube 핸들",
  "links.input.bilibili": "Bilibili UID",
  "links.input.xiaohongshu": "Xiaohongshu 프로필 URL",
  "links.input.wechat": "위챗 공식 계정 ID",
  "links.input.email": "Email",
  "links.input.calendar": "예약 경로",
  "links.input.website": "Website URL",
  "links.input.newsletter": "Newsletter URL",
  "links.input.tiktok": "TikTok 핸들",
  "links.input.threads": "Threads 핸들",
  "links.input.mastodon": "Mastodon URL",
  "links.input.dribbble": "Dribbble 핸들",
  "links.input.jike": "Jike 프로필 URL",
  "links.input.other": "링크 URL",
  "links.input.calendar.cal": "Cal.com 경로",
  "links.input.calendar.calendly": "Calendly 경로",
  "links.input.calendar.google": "Google Calendar 예약 페이지",
  "links.input.calendar.microsoft": "Microsoft Bookings 링크",
  "links.input.calendar.hubspot": "HubSpot Meetings 링크",
  "links.input.calendar.savvycal": "SavvyCal 경로",
  "links.input.calendar.tidycal": "TidyCal 경로",
  "links.input.calendar.zcal": "zcal 경로",
  "links.hint.handle": "URL가 아닌 핸들만 입력하세요.",
  "links.hint.uid": "프로필 URL가 아닌 UID만 입력하세요.",
  "links.hint.slug": "전체 URL가 아닌 경로만 입력하세요.",
  "links.hint.email": "그러면 mailto 링크가 생성됩니다.",
  "links.hint.text": "공개 페이지를 클릭하면 이 값이 복사됩니다.",
  "links.hint.url": "이 플랫폼에 유효한 https:// 링크를 입력하세요.",
  "links.hint.calendarSlug": "전체 URL가 아닌 사용자 이름이나 예약 경로만 입력하세요.",
  "links.hint.calendarUrl": "이 플랫폼의 전체 예약 페이지 URL를 입력하세요.",
  "rich.toolbarAria": "본문 서식 도구 모음",
  "rich.heading": "섹션 제목",
  "rich.paragraph": "절",
  "rich.bold": "용감한",
  "rich.boldFallback": "굵은 글씨",
  "rich.italic": "이탤릭체",
  "rich.italicFallback": "이탤릭체 텍스트",
  "rich.code": "인라인 코드",
  "rich.comment": "주석 전환",
  "rich.ul": "글머리 기호 목록",
  "rich.ol": "번호가 매겨진 목록",
  "rich.link": "링크",
  "rich.linkPrompt": "https:// 또는 mailto: 링크를 입력하세요.",
  "rich.linkInvalid": "링크는 https:// 또는 mailto만 지원합니다.",
  "rich.linkFallback": "링크 텍스트",
  "rich.aria": "30초 소개 본문",
  "rich.more": "기타 서식",
  "rich.quote": "인용",
  "rich.strikethrough": "취소선",
  "rich.strikethroughFallback": "취소선 텍스트",
  "rich.codeBlock": "코드 블록",
  "rich.codeBlockFallback": "코드",
  "rich.taskList": "작업 목록",
  "rich.table": "표",
  "rich.tableSkeleton": "| 항목 | 설명 |\n| --- | --- |\n| 항목 1 | 설명 1 |\n| 항목 2 | 설명 2 |",
  "rich.indent": "들여쓰기 늘리기",
  "rich.outdent": "들여쓰기 줄이기",
  "rich.placeholder": "30초 안에 읽을 수 있는 Markdown 소개를 작성하세요...",
  "feedback.aria": "피드백 작성",
  "feedback.timeTitle": "예상 독서 시간",
  "feedback.preview": "시사",
  "feedback.previewMenu": "미리보기 메뉴 열기",
  "feedback.openAcceptancePreview": "공개수락 미리보기",
  "feedback.acceptancePreviewCopy": "이 기기에서 공개 페이지 결과 보기",
  "feedback.noIssues": "차단 문제 없음",
  "feedback.prePublish": "사전 게시 수표",
  "feedback.ready": "차단제 없음",
  "feedback.itemCount": "{count} 항목",
  "feedback.valid": "콘텐츠가 게시 확인을 통과합니다.",
  "issue.action.displayName": "이름 추가",
  "issue.action.oneLineIdentity": "신원 추가",
  "issue.action.tags": "태그 추가",
  "issue.action.body": "본문으로 돌아가기",
  "issue.action.handle": "주소 선택",
  "issue.action.links": "링크 관리",
  "issue.action.view": "보다",
  "issue.short.displayName": "이름이 누락되었습니다.",
  "issue.short.oneLineIdentity": "누락된 신원",
  "issue.short.tags": "태그 누락",
  "issue.short.handle": "주소 누락",
  "issue.short.readingTime": "60초 초과",
  "issue.short.readingTimeLong": "30초 초과",
  "issue.short.readingTimeShort": "콘텐츠가 너무 적음",
  "issue.short.bodyPlaceholder": "본문의 예시 내용",
  "issue.short.bodyFormat": "본문 형식",
  "issue.short.links": "링크 문제",
  "issue.short.linksEmpty": "링크를 추가할 수 있습니다.",
  "issue.short.pending": "작업이 필요함",
  "issue.summary.more": "수정할 {count} 항목",
  "publish.title.create": "게시 확인",
  "publish.title.update": "변경사항 확인",
  "publish.action.create": "30s.to에 게시",
  "publish.action.update": "변경사항 게시",
  "publish.closeAria": "게시 확인 닫기",
  "publish.address": "공개 주소",
  "publish.unpublishedChanges": "게시되지 않은 변경사항",
  "publish.handleChanged": "공개 주소가 @{oldHandle}에서 @{newHandle}(으)로 변경됩니다. 이전 주소는 30일간 이동 안내되며, 변경 후 180일이 지나면 다른 사람에게 배정될 수 있습니다. 기존 링크에 다른 사람의 소개가 표시될 수 있습니다.",
  "publish.readingTime": "독서시간",
  "publish.status": "상태",
  "publish.ready": "준비가 된",
  "publish.todo": "개선할 {count} 항목",
  "publish.visibility": "공개 범위",
  "publish.visibility.indexed": "검색 엔진 수집 허용",
  "publish.visibility.unlisted": "링크 공개",
  "publish.visibility.indexedNote": "누구나 볼 수 있으며 검색 결과에 표시될 수 있어요.",
  "publish.visibility.unlistedNote": "링크를 가진 사람은 누구나 볼 수 있으며, 검색 엔진에 직접 제출하지 않아요.",
  "publish.visibility.publicNote": "두 방식 모두 공개 페이지이며 링크를 전달할 수 있어요. 나만 보려면 초안으로 유지하세요.",
  "publish.publicContent": "게시하면 이름, 소개, 태그, 본문, 링크가 공개돼요. 작성자 주석은 표시되지 않지만 비밀 정보는 저장하지 마세요.",
  "publish.noop": "공개 페이지는 이미 최신 상태입니다. 다시 게시하기 전에 콘텐츠나 공개 상태를 변경하세요.",
  "publish.valid": "콘텐츠가 게시 확인을 통과합니다.",
  "handleEdit.title": "공개 주소 수정",
  "handleEdit.label": "30s.to 주소",
  "handleEdit.help.changed": "저장은 초안만 변경합니다. 게시 후 이전 주소는 30일간 이동 안내되며 180일 후 다른 사람에게 배정될 수 있습니다.",
  "handleEdit.help.saved": "초안으로 저장되었습니다. 게시 시 가용성이 다시 확인됩니다.",
  "handleEdit.note": "현재 공개 주소는 여전히 30s.to/@{handle}입니다. 새 주소는 게시 후 적용됩니다.",
  "handleEdit.save": "초안에 저장",
  "conflict.title": "초안 버전 선택",
  "conflict.copy": "이 장치와 클라우드 모두에 게시되지 않은 콘텐츠가 있습니다. 선택한 내용이 다음 편집 버전이 됩니다.",
  "conflict.useLocal": "로컬 초안 사용",
  "conflict.useLocalCopy": "현재 페이지 콘텐츠를 유지하고 클라우드에 동기화하세요.",
  "conflict.useCloud": "클라우드 초안 사용",
  "conflict.untitled": "제목 없음",
  "conflict.cloudVersion": "클라우드에 저장된 버전",
  "conflict.modifiedAt": "마지막 수정 · {time}",
  "conflict.time.justNow": "방금",
  "conflict.time.minutesAgo": "{count}분 전",
  "conflict.time.hoursAgo": "{count}시간 전",
  "conflict.time.daysAgo": "{count}일 전",
  "authModal.title": "30s.to에 로그인",
  "authModal.copy": "로그인 후 초안이 클라우드에 동기화되어 게시가 더 안정적입니다.",
  "login.page.eyebrow": "계정",
  "login.page.title": "30s.to에 로그인",
  "login.page.copy": "초안을 동기화하고, 공개 페이지를 게시하고, 초대를 관리하세요.",
  "login.invalidEmail": "유효한 이메일을 입력하세요.",
  "login.sendFailed": "코드를 보낼 수 없습니다.",
  "login.devCodeReady": "로컬 개발 코드가 생성되었습니다.",
  "login.codeSent": "코드가 전송되었습니다. 이메일을 확인하세요.",
  "login.networkSendFailed": "코드를 보낼 수 없습니다. 연결을 확인하세요.",
  "login.invalidCode": "6자리 코드를 입력하세요.",
  "login.codeInvalid": "코드가 잘못되었거나 만료되었습니다.",
  "login.failed": "로그인에 실패했습니다. 나중에 다시 시도하세요.",
  "login.sendBusy": "배상...",
  "login.resendCode": "코드 재전송",
  "login.sendCode": "코드 보내기",
  "login.localCode": "지역 개발 코드: {code}",
  "login.code": "암호",
  "login.codePlaceholder": "6자리",
  "login.inviteHelp": "공개 베타에는 초대 코드가 필요합니다. 확인을 통해 계정이 활성화됩니다.",
  "login.verifyBusy": "확인 중...",
  "login.verifyInvite": "초대 확인 및 로그인",
  "login.verify": "로그인하고 계속하세요",
  "login.footnote": "비밀번호 없는 로그인. 신규 사용자는 이메일 확인 후 초대를 통해 활성화됩니다.",
  "login.google": "Google로 계속하기",
  "login.github": "GitHub로 계속하기",
  "login.emailDivider": "아니면 이메일을 이용하세요",
  "login.oauthFailed": "소셜 로그인이 완료되지 않았습니다. 다시 시도하거나 이메일 로그인을 사용하세요.",
  "login.linkTitle": "계정 이메일 확인",
  "login.linkPageCopy": "30s.to 계정은 이미 이 이메일을 사용하고 있습니다. 확인 후에만 연결합니다. 계정은 자동으로 병합되지 않습니다.",
  "login.linkCopy": "{email}로 코드를 보내드리겠습니다. 여기에서는 이메일을 변경할 수 없습니다.",
  "login.linkVerify": "확인 및 연결",
  "login.linkRequired": "기존 계정이 발견되었습니다. 계속하려면 이메일을 확인하세요.",
  "login.activateTitle": "30s.to 활성화",
  "login.activatePageCopy": "귀하의 소셜 신원이 확인되었습니다. 초대가 성공할 때까지 영구 계정이 생성되지 않습니다.",
  "login.activateCopy": "공개 베타에는 초대가 필요합니다. 계정 생성이 성공한 경우에만 상환됩니다.",
  "login.activationOpenCopy": "현재 가입이 열려 있습니다. 계속하면 계정이 활성화됩니다.",
  "login.activationClosedCopy": "현재 새 계정 활성화가 일시 중지되었습니다. 기존 계정은 계속 로그인할 수 있습니다.",
  "login.activate": "활성화하고 계속하기",
  "login.inviteRequired": "Email가 확인되었습니다. 활성화하려면 초대를 사용하세요.",
  "login.useEmailInstead": "대신 이메일 로그인을 사용하세요",
  "preview.emptyEyebrow": "시사",
  "preview.emptyTitle": "미리 볼 수 있는 소개가 없습니다.",
  "preview.backToEdit": "편집으로 돌아가기",
  "preview.edit": "편집하다",
  "preview.localNoteAria": "로컬 미리보기 참고사항",
  "preview.localNote": "현지 수용",
  "preview.localTitle": "이 장치에서 초안 미리보기",
  "preview.themePicker": "테마 전환기",
  "preview.themeGroup": "테마 선택",
  "preview.themeFree": "베이스",
  "preview.themePro": "찬성",
  "preview.mobileAria": "모바일 공개 페이지 미리보기",
  "preview.close": "미리보기 닫기",
  "preview.editorTitle": "시사",
  "preview.publicTitle": "공개 페이지 미리보기",
  "preview.shareCardButton": "테마 카드 보기",
  "preview.shareCardDialogTitle": "테마 카드 미리보기",
  "preview.shareCardTitle": "{theme} 테마 카드",
  "preview.shareCardLogin": "실제 미리보기를 렌더링하려면 로그인하세요.",
  "preview.shareCardLoading": "테마 카드 렌더링 중…",
  "preview.shareCardError": "카드 미리보기를 일시적으로 사용할 수 없습니다.",
  "preview.shareCardNote": "테마 카드는 공개 페이지와 동일한 시각적 언어를 사용합니다. 범용 카드는 Dashboard에서 사용할 수 있습니다.",
  "public.copySuccess": "{label}를 복사했습니다.",
  "public.copyFailed": "복사에 실패했습니다. 수동으로 복사해 주세요.",
  "public.createMine": "내 소개 만들기",
  "public.report": "이 페이지 신고",
  "public.ownerAria": "개인관리 항목",
  "public.owner.manage": "관리하다",
  "public.owner.edit": "편집하다",
  "public.status.unavailable": "없는",
  "public.status.notFound": "404",
  "public.status.moderated": "이 30초 소개는 사용할 수 없습니다.",
  "public.status.frozen": "이 공개 주소는 사용할 수 없습니다.",
  "public.status.unpublished": "이 30초 인트로는 아직 게시되지 않았습니다.",
  "theme.footer": "30s.to로 제작",
  "theme.fallback.name": "당신의 이름",
  "theme.fallback.nameUpper": "당신의 이름",
  "theme.fallback.nameNoir": "이름",
  "theme.fallback.nameIndex": "존 도",
  "theme.fallback.identity": "당신은 무엇을합니까?",
  "theme.fallback.identityUpper": "귀하의 한 줄 정체성과 임무",
  "theme.fallback.identityIndex": "알려지지 않은",
  "theme.fallback.identityNoir": "신원",
  "theme.fallback.terminalName": "손님",
  "theme.fallback.terminalIntro": "아직 짧은 소개가 없습니다.",
  "theme.terminal.commandLabel": "터미널 명령",
  "theme.terminal.commandSubmit": "명령 실행",
  "theme.terminal.outputLabel": "대화형 터미널 출력",
  "theme.connect": "연결하다",
  "theme.markdown.tableRegion": "본문 표, 가로 스크롤 가능",
  "theme.markdown.task": "작업",
  "theme.tags": "태그",
  "theme.verified": "확인됨",
  "theme.name": "이름",
  "theme.identityLabel": "신원",
  "theme.keywords": "키워드",
  "theme.scroll": "스크롤",
  "theme.pixel.previous": "이전 화면",
  "theme.pixel.next": "다음 화면",
  "theme.pixel.screen": "{total}의 화면 {current}",
  "theme.arcade.stage": "스테이지 {current} / {total}",
  "theme.noise.reseed": "리시드 노이즈",
  "theme.readingTime": "약 {seconds}초 분량",
  "theme.readingUnit": "초 분량",
  "theme.letter.greeting": "안녕하세요,",
  "theme.letter.signoff": "감사합니다,",
  "theme.letter.postscript": "여기에서 저를 찾을 수 있어요",
  "theme.letter.written": "{date} 작성",
  "dashboard.loginTitle": "귀하의 소개를 관리하려면 로그인하세요.",
  "dashboard.loginAction": "로그인 및 관리",
  "dashboard.bannedTitle": "이 계정은 현재 사용할 수 없습니다.",
  "dashboard.bannedCopy": "이것이 실수라고 생각되면 신고 및 이의신청 항목을 통해 문의해 주세요.",
  "connections.kicker": "계정",
  "connections.title": "로그인 방법",
  "connections.settingsKicker": "설정",
  "connections.settingsTitle": "계정 및 연결",
  "connections.settingsCopy": "로그인 ID와 타사 Agent 권한을 관리합니다.",
  "connections.backToDashboard": "관리 페이지로 돌아가기",
  "connections.emailCode": "이메일 인증 코드",
  "connections.alwaysAvailable": "항상 사용 가능",
  "connections.connect": "연결하다",
  "connections.disconnect": "30s.to 링크 제거",
  "connections.notConnected": "연결되지 않음",
  "connections.noEmail": "제공된 이메일이 없습니다.",
  "connections.emailVerified": "Email 확인됨",
  "connections.connected": "연결됨",
  "connections.unavailable": "활성화되지 않음",
  "connections.confirm": "30s.to에서 {provider} 링크를 제거하시겠습니까? Email 로그인은 계속 가능합니다.",
  "connections.removed": "30s.to에서 ID 링크가 제거되었습니다.",
  "connections.failed": "로그인 방법을 업데이트할 수 없습니다. 나중에 다시 시도하세요.",
  "connections.help": "이는 30s.to ID 매핑만 제거합니다. 공급자 액세스 권한은 취소되지 않습니다. 공급자 액세스 관리:",
  "agentConnections.kicker": "Agent",
  "agentConnections.title": "Agent 연결",
  "agentConnections.copy": "Skill 하나를 설치해 자주 쓰는 Agent가 정보를 모으고 글을 작성하며 30s.to 초안을 안전하게 업데이트하도록 하세요.",
  "agentConnections.addTitle": "새 Agent 연결",
  "agentConnections.addCopy": "연결 URL 및 설정 단계 보기",
  "agentConnections.examplesDisclosure": "사용 예시 보기",
  "settings.title": "설정",
  "settings.copy": "계정, 보안, 외부 연결 및 30s.to 요금제를 관리합니다.",
  "settings.navAria": "설정 카테고리",
  "settings.account.title": "계정",
  "settings.account.copy": "30s.to ID와 프로필로 이동하는 곳입니다.",
  "settings.account.email": "계정 이메일",
  "settings.account.profile": "프로필",
  "settings.account.plan": "현재 요금제",
  "settings.account.manageProfile": "프로필 관리",
  "settings.login.copy": "30s.to 로그인에 사용할 수 있는 ID를 관리합니다.",
  "settings.billing.copy": "현재 요금제, 갱신 상태 및 결제 관리 메뉴를 확인합니다.",
  "settings.invites.copy": "Public Beta 초대 한도와 최근 초대 코드를 관리합니다.",
  "agentConnections.endpoint": "연결 URL",
  "agentConnections.copyAction": "복사",
  "agentConnections.copied": "복사됨",
  "agentConnections.copyFailed": "복사하지 못했습니다. URL을 직접 복사해 주세요.",
  "agentConnections.endpointCopied": "연결 URL을 복사했습니다.",
  "agentConnections.stepsAria": "Agent 연결 단계",
  "agentConnections.step1": "Agent의 MCP 또는 커넥터 설정에서 원격 서비스를 추가합니다.",
  "agentConnections.step2": "연결 URL을 붙여 넣고 30s.to에 로그인해 접근을 승인합니다.",
  "agentConnections.step3": "Agent에게 수정할 내용을 말한 뒤 30s.to로 돌아와 초안을 검토합니다.",
  "agentConnections.examplesTitle": "이렇게 요청해 보세요",
  "agentConnections.exampleFirst": "내 30s.to 프로필과 형식 규칙을 읽고 첫 소개를 완성해 줘.",
  "agentConnections.exampleSection": "기존 말투를 유지하고 ‘지금’ 섹션만 다시 써 줘.",
  "agentConnections.exampleShorten": "전체 소개를 30초 안에 읽을 수 있게 줄여 줘. 게시하지는 마.",
  "agentConnections.copyExample": "예시 {number} 복사",
  "agentConnections.promptCopied": "예시 요청을 복사했습니다.",
  "agentConnections.boundary": "Agent는 초안을 읽고 수정할 수만 있으며 게시하거나 공개를 중단할 수 없습니다.",
  "agentConnections.authorizedTitle": "승인된 연결",
  "agentConnections.empty": "승인된 Agent 연결이 없습니다.",
  "agentConnections.disabled": "Agent 연결이 아직 활성화되지 않았습니다.",
  "agentConnections.scopeRead": "초안 읽기",
  "agentConnections.scopeWrite": "초안 수정",
  "agentConnections.connectedAt": "{date} 연결",
  "agentConnections.selfReported": "클라이언트 이름은 클라이언트가 직접 제공했습니다",
  "agentConnections.revoke": "취소",
  "agentConnections.confirm": "{client} 연결을 취소할까요? 이 클라이언트는 더 이상 30s.to 초안에 접근할 수 없습니다.",
  "agentConnections.confirmSkill": "30s.to Skill 연결을 취소할까요? 이 Skill을 사용하는 로컬 Agent가 30s.to에서 로그아웃됩니다.",
  "agentConnections.revoked": "Agent 연결을 취소했습니다.",
  "agentConnections.failed": "Agent 연결을 업데이트하지 못했습니다. 나중에 다시 시도하세요.",
  "agentConnections.manualTitle": "Remote MCP 수동 연결",
  "agentConnections.manualCopy": "고급: Remote MCP 호환 클라이언트를 별도로 승인",
  "skill.meta.title": "30s.to Skill — Agent가 쓰는 30초 소개",
  "skill.meta.description": "사이트, 프로젝트, 포트폴리오 링크를 보내세요. Agent가 자료를 조사하고 인터뷰해 30초 자기소개를 써 줍니다.",
  "skill.kicker": "30s.to Skill",
  "skill.title": "자기소개는\n늘 쓰는 에이전트와 함께.",
  "skill.copy": "링크 몇 개만 보내세요. 에이전트가 당신을 알아보고 30초 안에 읽을 수 있는 자기소개를 써 줍니다.",
  "skill.processTitle": "Agent가 대신 쓰는 과정",
  "skill.process.clues.title": "링크 보내기",
  "skill.process.clues.copy": "공개 프로필, 프로젝트 사이트, 포트폴리오.",
  "skill.process.research.title": "충분히 조사한 뒤 인터뷰하기",
  "skill.process.research.copy": "홈페이지와 프로젝트, 작업물을 깊이 살펴 핵심을 정리한 뒤, 자료에 없는 내용을 인터뷰로 채웁니다.",
  "skill.process.profile.title": "자기소개 완성하기",
  "skill.process.profile.copy": "내용과 말투를 함께 다듬어 나다운 소개를 완성합니다.",
  "skill.installTitle": "Agent에 설치하기",
  "skill.installCopy": "설치 지시문을 복사해 평소 쓰는 에이전트에 붙여넣고 보내세요.",
  "skill.promptLabel": "설치 지시문",
  "skill.copyPrompt": "설치 지시문 복사",
  "skill.promptCopied": "설치 지시문을 복사했습니다. 다음으로 자주 쓰는 Agent를 열어 붙여넣고 보내세요.",
  "skill.copyFailed": "복사하지 못했습니다. 아래 설치 지시문을 선택해 직접 복사해 주세요.",
  "skill.startTitle": "시작하는 방법",
  "skill.start.install": "30s.to Skill 설치",
  "skill.start.chat": "대화 시작하기",
  "skill.start.chatCopy": "설치가 끝나면 새 대화에서 이렇게 말해 보세요:",
  "skill.start.prompt": "30s.to로 자기소개 쓰는 걸 도와줘.",
  "dashboard.kicker": "내 소개",
  "dashboard.defaultTitle": "나의 30초 소개",
  "dashboard.primaryEdit": "계속 편집",
  "dashboard.primaryCreate": "만들기 시작",
  "dashboard.unpublished": "게시되지 않음",
  "dashboard.unselected": "선택되지 않음",
  "dashboard.confirmDiscard": "게시되지 않은 변경사항을 삭제하고 현재 공개 버전을 복원하시겠습니까?",
  "dashboard.discardFailed": "변경사항을 삭제할 수 없습니다.",
  "dashboard.discardConflict": "이 초안이 다른 곳에서 업데이트되었습니다. 페이지를 새로고침해 확인한 후 다시 시도하세요.",
  "dashboard.discardNetworkFailed": "변경사항을 삭제할 수 없습니다. 나중에 다시 시도하세요.",
  "dashboard.discardDone": "현재 공개 버전으로 복원되었습니다.",
  "dashboard.statusAria": "현황",
  "dashboard.versionAria": "버전 관계",
  "dashboard.publicPage": "공개 페이지",
  "dashboard.indexingAllowed": "검색 수집 허용",
  "dashboard.indexingBlocked": "링크 공개",
  "dashboard.publicVersion": "게시된 버전",
  "dashboard.invisible": "아직 다른 사람에게 표시되지 않음",
  "dashboard.draft": "초안",
  "dashboard.currentDraft": "현재 편집 가능한 버전",
  "dashboard.draftSynced": "공개 페이지와 동기화됨",
  "dashboard.editableVersionEmpty": "편집 가능한 버전 · 생성되지 않음",
  "dashboard.editableVersionDirty": "편집 가능한 버전 · 변경사항이 게시되지 않음",
  "dashboard.editableVersionSynced": "편집 가능한 버전 · 공개 페이지와 일치",
  "dashboard.editableVersionUnpublished": "편집 가능한 버전 · 게시되지 않음",
  "dashboard.betaActive": "활동적인",
  "dashboard.betaInactive": "비활성",
  "dashboard.adminCanPublish": "관리자 계정으로 게시 가능",
  "dashboard.betaAccessNote": "공개 베타 게시 액세스",
  "dashboard.visibility": "공개 범위",
  "dashboard.chooseOnPublish": "게시 확인 시 선택",
  "dashboard.snapshot": "스냅 사진",
  "dashboard.snapshotAfterPublish": "게시 후 공개 페이지 스냅샷이 생성됩니다.",
  "dashboard.publishDetailsAria": "출판 세부정보",
  "dashboard.actionsAria": "관리 조치",
  "dashboard.nextAction": "다음 단계",
  "dashboard.openPublicPage": "공개 페이지 열기",
  "dashboard.changeVisibility": "공개 범위 변경",
  "dashboard.unpublish": "공개 중단",
  "dashboard.unpublishTitle": "공개를 중단할까요?",
  "dashboard.unpublishDescription": "공개 페이지에 즉시 접근할 수 없게 됩니다. 초안과 공개 주소는 유지되어 나중에 다시 게시할 수 있어요.",
  "dashboard.unpublishWarning": "검색 엔진이나 다른 사람이 이미 저장한 사본은 바로 사라지지 않을 수 있어요.",
  "dashboard.unpublishConfirm": "공개 중단",
  "dashboard.unpublishBusy": "중단하는 중...",
  "dashboard.unpublishSuccess": "공개 페이지를 중단했어요. 초안과 공개 주소는 유지됩니다.",
  "dashboard.unpublishFailed": "공개를 중단하지 못했어요. 잠시 후 다시 시도하세요.",
  "dashboard.discardBusy": "복원 중...",
  "dashboard.discard": "변경사항 취소",
  "dashboard.metricsAria": "경량 데이터",
  "dashboard.views": "조회수",
  "dashboard.clicks": "클릭수",
  "dashboard.readingTime": "독서시간",
  "dashboard.theme": "주제",
  "dashboard.noTheme": "선택되지 않음",
  "dashboard.visibility.indexed": "검색 엔진 수집 허용",
  "dashboard.visibility.unlisted": "링크 공개",
  "dashboard.visibility.indexedNote": "검색 결과에 표시될 수 있어요",
  "dashboard.visibility.unlistedNote": "직접 링크를 가진 사람은 계속 볼 수 있어요",
  "dashboard.snapshot.ready": "캐시 준비됨",
  "dashboard.snapshot.failed": "D1 대체",
  "dashboard.snapshot.none": "생성되지 않음",
  "dashboard.snapshot.readyNote": "KV에 작성된 공개 스냅샷",
  "dashboard.snapshot.failedNote": "공개 페이지는 D1 대체를 통해 계속 작동합니다.",
  "dashboard.snapshot.noneNote": "현재 게시된 버전에 사용할 수 있는 스냅샷이 없습니다.",
  "invite.title": "공개 베타에 친구 초대",
  "invite.remaining": "{remaining} / {quota}가 이번 달에 왼쪽으로 초대합니다.",
  "invite.generateFailed": "초대장을 생성할 수 없습니다.",
  "invite.generated": "초대 코드 {count}개를 생성했습니다. 이번에만 표시됩니다.",
  "invite.quotaUsed": "월별 초대 할당량이 사용되었습니다.",
  "invite.generating": "생성 중...",
  "invite.generate": "남은 {count}개 한 번에 생성",
  "invite.batchTitle": "이번에 생성한 초대 코드 {count}개",
  "invite.copyAll": "모든 코드 복사",
  "invite.copiedAll": "모든 코드를 복사했습니다",
  "invite.copyMessage": "공유 문구 복사",
  "invite.messageCopied": "공유 문구를 복사했습니다",
  "invite.share": "바로 공유",
  "invite.shared": "공유 창을 열었습니다.",
  "invite.shareFallback": "직접 공유를 지원하지 않아 공유 문구를 복사했습니다.",
  "invite.shareFailed": "공유할 수 없습니다. 공유 문구를 복사해 주세요.",
  "invite.shareMessage": "30s.to에서 30초 자기소개를 만들고 있어요. 당신도 한번 써 보세요.\n\n초대 코드:\n{codes}\n\n{url}에서 바로 시작하세요.",
  "invite.recentAria": "초대 코드 사용 상태",
  "invite.statusTitle": "사용 상태",
  "invite.statusSummary": "사용 가능 {active}개 · 사용됨 {redeemed}개 · 만료 {expired}개 · 취소 {revoked}개",
  "invite.status.revoked": "취소됨",
  "invite.status.redeemed": "사용된",
  "invite.status.expired": "만료됨",
  "invite.status.active": "사용 가능",
  "invite.copy": "복사",
  "invite.copied": "복사됨",
  "invite.showOnce": "한 번만 표시됨",
  "invite.expiryUnknown": "만료 알 수 없음",
  "invite.expiresAt": "{date}에 만료됨",
  "management.handlePending.title": "주소 변경 대기 중",
  "management.handlePending.description": "현재 공개 주소는 여전히 {publishedAddress}입니다. 게시하면 {draftAddress}가 활성화됩니다.",
  "management.handlePending.next": "{draftAddress}가 공개 주소가 되기 전에 변경 사항을 게시하세요.",
  "management.dirty.title": "게시되지 않은 변경사항",
  "management.dirty.description": "초안이 공개 페이지에 게시되지 않았습니다.",
  "management.dirty.next": "공개 페이지를 이 초안과 동기화하려면 변경사항을 게시하세요.",
  "management.published.title": "게시됨",
  "management.published.description": "공개 페이지가 최신 상태입니다.",
  "management.published.next": "공개 페이지가 동기화되었습니다. 조정하고 싶을 때 계속 편집하세요.",
  "management.unpublished.title": "널리 알려지지 않은",
  "management.unpublished.description": "이 인트로는 여전히 초안으로만 저장됩니다.",
  "management.unpublished.next": "다른 사람이 공개 주소를 방문하기 전에 게시하세요.",
  "management.empty.title": "아직 소개가 없습니다",
  "management.empty.description": "주소를 선택하고 30초 소개를 작성하세요.",
  "management.empty.next": "먼저 초안을 작성하세요. 사전 게시 수표는 편집기에 남아 있습니다.",
  "management.publish.create": "소개 게시",
  "management.publish.update": "변경사항 게시",
  "abuse.kicker": "신뢰와 안전",
  "abuse.title": "신고 페이지",
  "abuse.copy": "보고서는 안전 검토용으로만 사용됩니다. 귀하의 신원은 공개되지 않습니다.",
  "abuse.missingHandle": "보고 대상이 누락되었습니다.",
  "abuse.done": "신고가 접수되었습니다. 곧 검토하겠습니다.",
  "abuse.failed": "제출에 실패했습니다. 나중에 다시 시도하세요.",
  "abuse.reason.spam": "스팸",
  "abuse.reason.impersonation": "인격화",
  "abuse.reason.abuse": "괴롭힘 또는 증오",
  "abuse.reason.illegal": "불법 콘텐츠",
  "abuse.reason.other": "기타 문제",
  "abuse.submitBusy": "제출 중...",
  "abuse.submit": "보고서 제출",
  "terms.title": "서비스 약관",
  "privacy.title": "개인정보 보호정책",
  "validation.handle.required": "핸들을 입력하세요.",
  "validation.handle.invalid": "핸들은 영문 소문자 4~24자여야 합니다.",
  "validation.handle.reserved": "이 공개 주소는 사용할 수 없습니다. 다른 주소를 사용해 보세요.",
  "validation.handle.unavailable": "이 공개 주소는 사용할 수 없습니다. 다른 주소를 사용해 보세요.",
  "validation.handle.frozen": "이 공개 주소는 사용할 수 없습니다. 다른 주소를 사용해 보세요.",
  "validation.handle.protected": "이 공개 주소는 사용할 수 없습니다. 다른 주소를 사용해 보세요.",
  "validation.handle.checkFailed": "이 주소를 확인할 수 없습니다.",
  "validation.handle.changeLimit": "공개 주소는 30일에 한 번만 변경할 수 있습니다.",
  "validation.displayName.required": "이름이나 닉네임은 필수입니다.",
  "validation.identity.required": "한 줄 ID가 필요합니다.",
  "validation.tags.range": "1~5개의 태그를 추가하세요.",
  "validation.links.limit": "독립 링크는 최대 {limit}개까지 추가할 수 있습니다.",
  "validation.links.empty": "아직 링크가 없습니다. 소셜 프로필, 예약 페이지 또는 연락 방법을 추가할 수 있습니다.",
  "validation.input.tooLong": "입력은 최대 {limit}자까지 가능합니다.",
  "validation.body.placeholder": "본문에 {detail} 항목이 남아 있습니다. 실제 내용으로 바꾸거나 삭제하세요.",
  "validation.body.oldTemplate": "이전 본문 템플릿",
  "validation.body.readingTime": "현재 예상 읽기 시간은 {seconds}초입니다. {maximum}초 이내로 줄여 주세요.",
  "validation.body.readingTimeLong": "현재 예상 읽기 시간은 {seconds}초로, 권장 {recommended}초를 넘지만 게시할 수 있습니다.",
  "validation.body.readingTimeShort": "현재 예상 읽기 시간은 {seconds}초입니다. 최소 {minimum}초가 되도록 내용을 더해 보세요.",
  "validation.markdown.h1": "# 페이지 수준 제목은 지원되지 않습니다.",
  "validation.markdown.deepHeading": "### 및 더 깊은 제목은 지원되지 않습니다.",
  "validation.markdown.image": "이미지 구문은 지원되지 않습니다.",
  "validation.markdown.codeBlock": "코드 블록은 지원되지 않습니다.",
  "validation.markdown.taskList": "작업 목록은 지원되지 않습니다.",
  "validation.markdown.table": "테이블은 지원되지 않습니다.",
  "validation.markdown.footnote": "각주는 지원되지 않습니다.",
  "validation.markdown.html": "HTML 및 삽입은 지원되지 않습니다.",
  "validation.markdown.commentUnclosed": "본문 주석에 닫는 표시 -->가 없습니다.",
  "validation.markdown.commentStrayClose": "본문 주석에 여는 표시 <!--가 없습니다.",
  "validation.markdown.commentNested": "본문 주석 <!-- -->는 중첩할 수 없습니다.",
  "validation.markdown.nestedHeading": "섹션 제목은 문서 최상위에만 둘 수 있습니다",
  "validation.markdown.setextHeading": "Setext 제목은 지원되지 않습니다",
  "validation.markdown.headingInline": "섹션 제목에는 일반 텍스트만 사용할 수 있습니다",
  "validation.markdown.frontmatter": "frontmatter는 지원되지 않습니다",
  "validation.markdown.indentedCode": "들여쓰기 코드 블록은 지원되지 않습니다. 펜스 코드 블록을 사용하세요",
  "validation.markdown.codeFenceUnclosed": "코드 펜스의 닫는 표시가 없습니다",
  "validation.markdown.codeLanguage": "언어 태그는 1~32자의 영문, 숫자, _, +, -만 사용할 수 있습니다",
  "validation.markdown.listDepth": "목록은 최대 3단계까지 중첩할 수 있습니다",
  "validation.markdown.tableSize": "표는 최대 6열, 20행까지 지원합니다",
  "validation.markdown.linkProtocol": "본문 링크는 HTTPS와 이메일만 지원합니다",
  "validation.link.unsupportedType": "아직 지원되지 않는 링크 유형입니다. 웹사이트, 지원 플랫폼 또는 예약 링크를 선택하세요.",
  "validation.link.labelRequired": "링크 이름은 비워둘 수 없습니다.",
  "validation.link.providerRequired": "예약 플랫폼을 선택하세요.",
  "validation.link.valueRequired": "{label}는 비워둘 수 없습니다.",
  "validation.link.httpsOnly": "링크는 https://.만 지원합니다.",
  "validation.link.invalid": "유효한 링크를 입력하세요.",
  "validation.link.validEmail": "유효한 이메일을 입력하세요.",
  "validation.link.validGithub": "유효한 GitHub 핸들을 입력하세요.",
  "validation.link.validBilibili": "유효한 Bilibili UID를 입력하세요.",
  "validation.link.validXiaohongshu": "유효한 Xiaohongshu 프로필 링크를 입력하세요.",
  "validation.link.validGoogleCalendar": "유효한 Google Calendar 예약 링크를 입력하세요.",
  "validation.link.validMicrosoftBookings": "유효한 Microsoft Bookings 링크를 입력하세요.",
  "validation.theme.proRequired": "이 테마를 게시하려면 30s Pro가 필요합니다.",
  "validation.link.validHubSpot": "유효한 HubSpot Meetings 링크를 입력하세요.",
  "validation.account.banned": "지금은 이 계정을 게시할 수 없습니다.",
  "validation.account.login": "먼저 로그인해주세요.",
  "validation.account.invite": "먼저 초대 코드로 계정을 활성화하세요.",
  "validation.publish.failed": "게시하지 못했습니다. 나중에 다시 시도하세요.",
  "validation.turnstile.required": "보안 확인을 완료하세요.",
  "validation.report.missing": "신고할 페이지가 없습니다.",
  "validation.report.reason": "신고 사유를 선택하세요.",
  "validation.report.notReportable": "지금은 이 페이지를 신고할 수 없습니다.",
  "common.listSeparator": ",",
  "dashboard.section.status": "상태",
  "dashboard.section.performance": "성능",
  "dashboard.fullAnalytics": "전체 분석 보기",
  "dashboard.shareCard": "카드 공유",
  "dashboard.timestamp.notPublished": "게시되지 않음",
  "dashboard.timestamp.notEdited": "편집되지 않음",
  "dashboard.timestamp.published": "게시된 {date} UTC",
  "dashboard.timestamp.edited": "{date} UTC를 편집했습니다.",
  "upgrade.publishTheme": "{theme} 게시",
  "upgrade.copy": "선택 내용은 저장되어 있으며 전체 미리보기를 계속 볼 수 있습니다. 업그레이드 후 다시 편집할 필요 없이 바로 게시할 수 있습니다.",
  "upgrade.benefit.themes": "모든 프리미엄 테마 게시",
  "upgrade.benefit.analytics": "읽기 시간 및 완료 확인",
  "upgrade.benefit.cards": "소셜 OG에 동기화된 테마 카드",
  "upgrade.seePro": "30s Pro 보기",
  "upgrade.keepEditing": "계속 수정하세요",
  "pro.meta.title": "30s Pro — 나답게 표현하기",
  "pro.meta.description": "프리미엄 테마, 읽기 흐름 분석, 테마 공유 카드로 30초 소개를 더 나답게 만드세요.",
  "pro.title": "나다움을 더 선명하게.",
  "pro.intro": "읽는 시간은 여전히 30초. Pro로 표현의 폭을 넓히고, 반응을 더 선명하게 보고, 공유용 콘텐츠도 바로 만들 수 있습니다.",
  "pro.priceAction": "Founding Price 보기",
  "pro.summaryAria": "Pro 혜택 요약",
  "pro.summaryThemes": "프리미엄 테마",
  "pro.summaryAnalytics": "일 분석",
  "pro.summaryShare": "공유 카드와 연동",
  "pro.benefitsKicker": "Pro 도구",
  "pro.benefitsTitle": "표현에서 전달까지.",
  "pro.benefit.themes.title": "프리미엄 테마",
  "pro.benefit.themes.body": "Terminal을 포함한 8가지 테마. Free에서 모두 미리 보고, Pro로 게시할 수 있습니다.",
  "pro.benefit.analytics.title": "읽기 품질",
  "pro.benefit.analytics.body": "방문 수를 넘어 유효 읽기 시간, 완독률, 도달 구간, 30·90·365일 추이와 링크 CTR까지 확인할 수 있습니다.",
  "pro.benefit.share.title": "공유도 나답게",
  "pro.benefit.share.body": "Free는 이름과 링크가 담긴 기본 카드 1종을 제공합니다. Pro에서는 공용 카드 2종과 테마별 전용 카드를 쓸 수 있습니다. 선택한 카드는 OG 이미지로도 적용되며 QR과 함께 공유하거나 저장할 수 있습니다.",
  "pro.benefit.attribution.title": "나만 남기기",
  "pro.benefit.attribution.body": "신고와 언어 선택 같은 필수 기능은 유지하면서 테마 안의 30s.to 표시는 숨길 수 있습니다.",
  "pro.pricingTitle": "일찍 시작할수록, 더 단순하게.",
  "pro.pricingBody": "구독을 유지하는 동안 Founding Price가 그대로 적용됩니다. 종료 후 다시 가입하면 당시 가격이 적용됩니다.",
  "pro.terminalAria": "Terminal Pro 테마 미리보기",
  "pro.checkout.continuous": "구독을 유지하면 가격 고정",
  "pro.checkout.intervalAria": "결제 주기",
  "pro.checkout.monthly": "월 결제",
  "pro.checkout.yearly": "연 결제",
  "pro.checkout.save": "$16 할인",
  "pro.checkout.periodYear": "년",
  "pro.checkout.periodMonth": "달",
  "pro.checkout.annualNote": "월 환산 ${price}, 월 결제보다 44% 저렴합니다.",
  "pro.checkout.monthlyNote": "매월 결제하고, 언제든 현재 기간이 끝날 때 취소할 수 있습니다.",
  "pro.checkout.includeThemes": "모든 프리미엄 테마",
  "pro.checkout.includeAnalytics": "읽기 품질 및 365일 분석",
  "pro.checkout.includeCards": "테마 카드, QR, OG",
  "pro.checkout.includeAttribution": "테마 안의 30s.to 표시 숨기기",
  "pro.checkout.manage": "내 Pro 관리",
  "pro.checkout.comingSoon": "결제 기능 준비 중",
  "pro.checkout.signIn": "로그인하고 업그레이드",
  "pro.checkout.inviteRequired": "Beta 초대가 필요합니다",
  "pro.checkout.opening": "보안 결제를 여는 중…",
  "pro.checkout.upgrade": "30s Pro로 업그레이드",
  "pro.checkout.footnote": "결제는 Creem이 안전하게 처리합니다. 세금은 결제 전에 표시되며 무료 체험 없이 자동 갱신됩니다.",
  "pro.checkout.unavailable": "일시적으로 결제가 불가능합니다. 다시 시도해 주세요.",
  "pro.checkout.networkError": "네트워크 연결에 실패했습니다. 다시 시도해 주세요.",
  "billing.panelAria": "프로 및 청구",
  "billing.plan": "요금제",
  "billing.status.canceling": "해지 예정",
  "billing.status.pastDue": "연체",
  "billing.status.active": "이용 중",
  "billing.status.free": "무료",
  "billing.yearly": "매년",
  "billing.monthly": "월간",
  "billing.basicPlan": "무료 요금제",
  "billing.ends": "{date} 종료",
  "billing.renews": "{date} 갱신",
  "billing.graceEnds": "유예 기간 종료: {date}",
  "billing.anomaly": "청구 상태를 직접 검토해야 합니다. support@30s.to로 문의하세요.",
  "billing.opening": "결제 관리 여는 중",
  "billing.manage": "결제 관리",
  "billing.upgrade": "프로로 업그레이드",
  "billing.openingHistory": "여는 중…",
  "billing.viewHistory": "청구 내역 보기",
  "billing.portalUnavailable": "일시적으로 결제 관리를 사용할 수 없습니다.",
  "billing.networkError": "네트워크 연결에 실패했습니다. 다시 시도해 주세요.",
  "billingReturn.kicker": "30s Pro · 결제 확인",
  "billingReturn.activeTitle": "Pro 이용이 시작됐어요",
  "billingReturn.failedTitle": "아직 결제가 확인되지 않았습니다",
  "billingReturn.waitingTitle": "결제 확인 중",
  "billingReturn.failedCopy": "결제가 아직 동기화 중일 수 있습니다. 나중에 대시보드를 다시 확인하세요. 반환 페이지만으로는 액세스가 허용되지 않습니다.",
  "billingReturn.waitingCopy": "결제 제공업체를 통해 귀하의 구독을 확인하는 중입니다. 이 페이지를 열어두세요.",
  "billingReturn.back": "관리 페이지로 돌아가기",
  "analytics.kicker": "30s Pro · 분석",
  "analytics.nav": "분석",
  "analytics.title": "방문부터 완독까지.",
  "analytics.copy": "개인을 추적하지 않고 방문부터 완독과 링크 상호작용까지 확인할 수 있어요. 날짜와 중복 제거는 UTC 기준입니다.",
  "analytics.rangeAria": "기간",
  "analytics.days": "{count}일",
  "analytics.uniqueVisitors": "순 방문자수",
  "analytics.rangeTotal": "최근 {count}일 합계",
  "analytics.averageReading": "평균 유효 읽기 시간",
  "analytics.activeReadingNote": "페이지가 보이고 활성화된 시간",
  "analytics.completionRate": "진척률",
  "analytics.completedVisitors": "{count}명이 끝까지 읽음",
  "analytics.overallCtr": "전체 CTR",
  "analytics.engagedVisitors": "{count}명이 링크와 상호작용함",
  "analytics.trafficTrend": "트래픽 동향",
  "analytics.dailyTrendAria": "일일 순방문자 추세",
  "analytics.readingCompletion": "읽기 완료",
  "analytics.dailyMaximum": "방문자 / 일일 최대",
  "analytics.visitorCount": "{count} 방문자",
  "analytics.topLinks": "상위 링크",
  "analytics.uniqueClickers": "링크를 클릭한 사용자",
  "analytics.linkTrendAria": "{label}의 일일 추세",
  "analytics.noInteractions": "아직 링크 상호작용이 없습니다.",
  "analytics.audienceOverview": "청중 개요",
  "analytics.pageLevel": "페이지 수준",
  "analytics.referrers": "유입 경로",
  "analytics.devices": "장치",
  "analytics.countries": "국가",
  "analytics.noData": "아직 데이터가 없습니다",
  "analytics.durationSeconds": "{seconds}초",
  "analytics.durationMinutes": "{minutes}분 {seconds}초",
  "share.card": "공유 카드",
  "share.variant.classic": "클래식",
  "share.variant.classicNote": "조용함",
  "share.variant.contact": "색인",
  "share.variant.contactNote": "구조화됨",
  "share.variant.theme": "{theme} 에디션",
  "share.variant.themeNote": "테마",
  "share.variant.universal": "유니버설",
  "share.saveFailed": "저장할 수 없습니다.",
  "share.styleUpdated": "스타일이 업데이트되었습니다.",
  "share.networkError": "네트워크 연결 실패",
  "share.linkCopied": "링크가 복사되었습니다",
  "share.copyFailed": "복사 실패",
  "share.text": "나의 30초 소개",
  "share.failed": "공유할 수 없습니다.",
  "share.published": "게시됨",
  "share.draft": "초안",
  "share.style": "스타일",
  "share.alt": "{name}의 공유 카드",
  "share.publishFirst": "공유하려면 게시하세요.",
  "share.action": "공유",
  "share.download": "다운로드",
  "share.openPublicPage": "공개 페이지 열기",
  "share.chooseStyle": "카드 스타일 선택",
  "share.close": "닫기",
  "share.cardStyle": "카드 스타일",
  "share.chooseOne": "스타일을 선택하세요",
  "share.chooseStyleAria": "공유 카드 스타일 선택",
  "share.saving": "저장 중",
  "validation.body.placeholderDetail.legacyTemplate": "이전 본문 템플릿",
  "validation.body.placeholderDetail.ellipsis": "`...` 자리 표시자",
  "validation.body.placeholderDetail.sampleLink": "샘플 링크 `https://example.com`",
  "validation.body.placeholderDetail.projectName": "`项目name` 자리 표시자",
  "validation.body.placeholderDetail.instruction": "템플릿 지침 텍스트",
  "analytics.gate.signInTitle": "로그인하면 분석을 볼 수 있어요",
  "analytics.gate.signInCopy": "방문 및 상호작용 데이터는 관리 페이지 안에 안전하게 보관됩니다.",
  "analytics.gate.signInAction": "로그인",
  "analytics.gate.proTitle": "소개가 끝까지 읽히는지 확인해 보세요.",
  "analytics.gate.proCopy": "유효 읽기 시간, 완독률, 진행률 분포, 30·90·365일 추이와 링크 CTR을 확인할 수 있습니다.",
  "analytics.gate.proAction": "30s Pro 보기",
  "analytics.gate.emptyTitle": "게시 후 이곳에서 데이터가 시작됩니다.",
  "analytics.gate.emptyCopy": "먼저 30초 소개를 완성하세요. 게시 후 방문 및 상호작용 추이를 확인할 수 있습니다.",
  "analytics.gate.emptyAction": "만들기 시작",
  "analytics.gate.privacyNote": "UTC 일별 집계 · 익명 중복 제거 · 원본 IP 저장 안 함",
  "handleEdit.previous": "보호 중인 이전 주소",
  "handleEdit.deadlines": "이동 안내 종료: {redirectDate}, 보호 종료: {releaseDate}.",
  "handleEdit.usePrevious": "이 주소 사용",
  "handleEdit.reclaimAvailable": "이전 주소를 다시 사용할 수 있습니다.",
  "publish.handleReclaimed": "이전 주소를 되찾는 것도 주소 변경입니다. 현재 주소에 새로 30일 이동 안내와 180일 보호 기간이 적용됩니다."
}
